import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import { DepartmentResp } from "@/views/attendance-management/attendance-group-management/attendance-group-application.interface";
import {
  EmployeeDetailResp,
  EmployeePageReq,
  EmployeePageResp,
  EmployeeReq,
  EmployeeSimpleListResp,
  ImportResp,
  Employee,
  FileResp,
  ActivatedUserResp,
} from "./employee.interface";

export class EmployeeService {
  static usePageApi(cb) {
    const api = (params: EmployeePageReq) => {
      const { departmentId, ...rest } = params;
      return HttpService.axios({
        method: "GET",
        url: `/department_user/${departmentId}/page`,
        params: rest,
      });
    };
    return HttpService.usePagination<EmployeePageResp>(api, { formatResult: cb });
  }

  //根据租户id获取管理id
  static useAdministratorIdApi() {
    const api = (tenantId) =>
      HttpService.axios({
        method: "GET",
        url: `/relocation/tenant_admin/getTenantAdmin/${tenantId}`,
      });
    return HttpService.useRequest<{ tenantUserId: string }>(api);
  }
  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/tenant_user/simple/list",
        params: {
          activatedStatus: 1,
          onJob: true,
          status: 1,
        },
      });
    return HttpService.useRequest<EmployeeSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/tenant_user/${id}`,
      });
    return HttpService.useRequest<EmployeeDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: EmployeeReq) =>
      HttpService.axios({
        method: "POST",
        url: "/tenant_user",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: EmployeeReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/tenant_user/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/tenant_user/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useJobStatusApi() {
    const api = (id: string, data) =>
      HttpService.axios({
        method: "PUT",
        url: `/tenant_user/${id}/onJob`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useInactiveCountApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/tenant_user/activatedStatusCount",
        params,
      });
    return HttpService.useRequest<void>(api);
  }

  static useActivatedUserApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/tenant_user/batch/activatedUsers",
        data,
      });
    return HttpService.useRequest<ActivatedUserResp>(api);
  }

  static useActivatedOneUserApi() {
    const api = (tenantUserId,params?) =>
      HttpService.axios({
        method: "put",
        url: `/tenant_user/${tenantUserId}/activatedUser/withVerificationCode`,
        params
      });
    return HttpService.useRequest<ActivatedUserResp>(api);
  }

  static useImportApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/tenant_user/import",
        data,
      });
    return HttpService.useRequest<ImportResp>(api);
  }

  static useExportApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: `/tenant_user/export`,
        data,
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useCheckedDeleteApi() {
    const api = (params) =>
      HttpService.axios({
        method: "DELETE",
        url: `/tenant_user/users`,
        params,
      });
    return HttpService.useRequest<void>(api);
  }
  static useExportApiAlert() {
    const api = (departmentId) =>
      HttpService.axios({
        method: "POST",
        url: `tenant_user/exportOfNotactive/${departmentId}`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  // static getDepartmentAPI() {
  //   const api = () =>
  //     HttpService.axios({
  //       method: "GET",
  //       url: `/auth/selectUserInfoByaccessToken`,
  //     });
  //   return HttpService.useRequest<DepartmentResp>(api);
  // }

  static useUploadEmployee() {
    const api = (url) =>
      HttpService.axios({
        url: "/department_user/preview",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<FileResp<Employee>>(api);
  }

  static useFinishEmployee() {
    const api = (data) =>
      HttpService.axios({
        url: "/tenant_user/imports",
        data,
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }

  static getAccountUsage() {
    const api = () =>
      HttpService.axios({
        method: "POST",
        url: `/auth/accountUsage`,
      });
    return HttpService.useRequest<DepartmentResp>(api);
  }
}
